import React from "react";
import GenericCRUD from "@/components/common/GenericCRUD";

const config = {
  resource: "admin/site/pricing",
  singular: "package",
  title: "Pricing Packages",
  subtitle: "Pricing tiers shown on the website.",
  titleKey: "name",
  columns: [
    { key: "order", label: "#", className: "w-16" },
    { key: "name", label: "Package", render: (r) => <span className="text-white font-medium">{r.name}</span> },
    { key: "description", label: "Description", render: (r) => <span className="text-white/60 truncate block max-w-sm">{r.description || r.desc}</span> },
    { key: "featured", label: "Featured", render: (r) => r.featured ? <span className="text-[#F59E0B] text-xs">★ Featured</span> : <span className="text-white/40 text-xs">—</span> },
    { key: "cta_label", label: "CTA", render: (r) => r.cta_label || r.cta || "—" },
  ],
  fields: [
    { key: "order", label: "Sort Order", type: "number" },
    { key: "name", label: "Package Name", type: "text" },
    { key: "description", label: "Description", type: "textarea" },
    { key: "features", label: "Includes / Features", type: "tags", hint: "Comma-separated list" },
    { key: "cta_label", label: "CTA Button Label", type: "text" },
    { key: "featured", label: "Featured Package", type: "switch" },
  ],
  defaultValues: { order: 1, name: "", description: "", features: [], cta_label: "", featured: false },
};

export default function Pricing() { return <GenericCRUD config={config} />; }
